import React from "react";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import Header from "../../Components/Header";
import AdminOverviewCardParent from "../../Components/IBAAdmin/AdminOverviewCardParent";
import AccountOpenBarChart from "../../Components/IBAAdmin/AccountOpenBarChart";
import TopPerformerCardAdminParent from "../../Components/IBAAdmin/TopPerformerCardAdminParent";

function AdminOverview() {
  return (
    <>
      <Header portal={"IBA"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="card-box ">
          <AdminOverviewCardParent />
          <AccountOpenBarChart />
          <TopPerformerCardAdminParent />
        </div>
      </main>
    </>
  );
}

export default AdminOverview;
